import React, { useEffect } from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import ConditionalFormItem from '../../ConditionalFormItem';
import { SERVICE_TYPE_MAP } from '../../../config/service-type-map';
import NATION_OPTIONS from "../../../config/nations";
import feeService from '../../../services/fee';

const { Option } = Select;

interface BarcodeBusinessTabProps {
  // 由外层传递 serviceType，本组件内部从 SERVICE_TYPE_MAP 计算选项
  serviceType: string;
  getReadOnlyProps?: (fieldType?: 'input' | 'select') => any;
  baseCountryMode?: boolean;
}

// 条形码业务信息 Tab：从 DynamicOrderForm 中的内联 BarcodeInfo 提取
const BarcodeSection: React.FC<BarcodeBusinessTabProps> = ({ serviceType, getReadOnlyProps = () => ({}), baseCountryMode = false }) => {
  const serviceTypeOptions = SERVICE_TYPE_MAP[serviceType] || {};
  const formInstance = Form.useFormInstance();
  const watchedNation = Form.useWatch('nation', formInstance);

  useEffect(() => {
    const loadChannels = async () => {
      try {
        if (!watchedNation) {
          return;
        }
        await feeService.getSubmitChannelsByNation(watchedNation as string);
      } catch (e) {
        // ignore
      }
    };
    loadChannels();
  }, [watchedNation]);
  return (
    <>
      {/* 子业务名称 */}
      <Form.Item label="子业务名称" name="sub_service" rules={[{ required: true, message: '请选择子业务名称' }]}>
        <Select placeholder="请选择具体的子业务名称">
          {(Object.entries(serviceTypeOptions) as [string, string][]).map(([key, value]) => (
            <Option key={key} value={key}>
              {value}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label={baseCountryMode ? '基础国家/地区' : '国家/地区'}
        name="nation"
        rules={[{ required: true, message: baseCountryMode ? '请选择基础国家/地区' : '请选择国家/地区' }]}
      >
        <Select
          placeholder={baseCountryMode ? '请选择基础国家/地区' : '请选择国家/地区'}
          showSearch
          filterOption={(input, option) =>
            String(option?.children || '').toLowerCase().includes(input.toLowerCase())
          }
          data-testid="order-nation"
        >
          {NATION_OPTIONS.map(option => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label="订单编号" name="order_no" rules={[{ required: true, message: '订单编号自动生成' }]}>
            <Input placeholder="自动生成" readOnly style={{ backgroundColor: '#f5f5f5', color: '#999' }} data-testid="order-no" />
          </Form.Item>
        </Col>
        {/*<Col span={12}>*/}
        {/*  <Form.Item label="案件编号" name="case_no">*/}
        {/*    <Input placeholder="客户内部/对外案件编号（可选）" data-testid="order-case-no" />*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
      </Row>

      <ConditionalFormItem condition="sub_service == increase">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="原始数量" name="quantity_original">
              <Input placeholder="请输入原始数量" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="本次增加数量" name="quantity_increase">
              <Input placeholder="请输入本次增加数量" />
            </Form.Item>
          </Col>
        </Row>
      </ConditionalFormItem>

      <ConditionalFormItem condition="sub_service = registration || sub_service = renewal || sub_service = cancellation">
        <Form.Item label="数量" name="quantity" rules={[{ required: true, message: '请输入数量' }]}>
          <Input placeholder="请输入数量" />
        </Form.Item>
      </ConditionalFormItem>

      <ConditionalFormItem condition="sub_service = renewal">
        <Form.Item label="续费周期" name="renewal_period">
          <Input placeholder="请输入续费周期" />
        </Form.Item>
      </ConditionalFormItem>

      <ConditionalFormItem condition="sub_service = registration">
        <Form.Item label="有效期限" name="validity_period">
          <Input placeholder="请输入有效期限" />
        </Form.Item>
      </ConditionalFormItem>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="注册号" name="registration_no" rules={[{ required: true, message: '请输入注册号' }]}>
            <Input placeholder="请输入注册号" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="公司名称" name="company_name" rules={[{ required: true, message: '请输入公司名称' }]}>
            <Input placeholder="请输入公司名称" />
          </Form.Item>
        </Col>
      </Row>

      <ConditionalFormItem condition="sub_service = cancellation">
        <Form.Item label="注销原因" name="cancellation_reason">
          <Input placeholder="请输入注销原因" />
        </Form.Item>
      </ConditionalFormItem>

      <Form.Item label="备注" name="remark">
        <Input.TextArea rows={3} placeholder="请输入备注信息" data-testid="order-remark" />
      </Form.Item>
    </>
  );
};

export default BarcodeSection;
